import bot from './bot.js';
export default {
    'es-mx': Object.assign({}, bot),
};
